import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './core/auth/auth.interceptor';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { icons } from './icons-provider';
import { provideNzIcons } from 'ng-zorro-antd/icon';
import { es_ES, provideNzI18n } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import es from '@angular/common/locales/es';

registerLocaleData(es);

/**
 * Configuración raíz de la aplicación (providers globales del bootstrap).
 *
 * Activa la detección de cambios zoneless, el router con las rutas de `app.routes`, el registro
 * estático de íconos de ng-zorro (evita descargarlos en runtime), la localización en español de
 * ng-zorro y `HttpClient` con `authInterceptor`, que adjunta el JWT y renueva la sesión ante un 401.
 * El locale `es` de Angular se registra arriba para que los pipes de fecha y moneda formateen en español.
 */
export const appConfig: ApplicationConfig = {
    providers: [
        provideBrowserGlobalErrorListeners(),
        provideZonelessChangeDetection(),
        provideRouter(routes),
        provideNzIcons(icons),
        provideNzI18n(es_ES),
        provideHttpClient(withInterceptors([authInterceptor])),
        provideAnimations()
    ]
};
